import { Image } from "@react-pdf/renderer";

const PdfSignatureImage = ({ src }) => (
  <Image style={{ width: 200, height: 60 }} src={src} />
);

export default PdfSignatureImage;
